//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import common from "@/assets/js/Common.js";
import api from "@/assets/js/Api.js";

import navbar from '@/components/ui/navbar'
import loadmore from '@/components/ui/loadmore'
import cardbox from '@/components/ui/cardbox'
import buttonbox from '@/components/ui/buttonbox'

import shopCart from '@/components/cusShopCart'
import mainMenuTab from '@/components/mainMenuTab'

export default {
    components: {
        shopCart, mainMenuTab, navbar, loadmore, cardbox, buttonbox,
    },
    data(){
        return {
            orderInfo: {
                storeCoupon: {},
                spec_id: [],
            },
            priceList: [],
            payType: [

            ],
            payInfo: null,
        }
    },
    methods:{

        // 提交订单
        submit(){
// console.log(this.orderInfo.out_trade_no)
            // 如果外部订单号存在
            if(this.orderInfo.out_trade_no){
                this.queryWxSign(this.orderInfo.out_trade_no);
                return;
            }

            const payTypeStatus = this.payInfo ? this.payInfo.type : this.payType[0].type;
            const opts = {
                url: api.submitOrder,
                data: {
                    order_info: JSON.stringify([{
                        store_id: this.orderInfo.store_id,
                        spec_id: this.orderInfo.spec_id,
                        coupon: this.orderInfo.coupon,
                        addr_id: this.orderInfo.addr_id,
                        express_type: this.orderInfo.express_type,
                        user_message: this.orderInfo.user_message,
                        pay_type: payTypeStatus,
                    }]),
                }
            }

            common.query(opts).then(res=>{
                if(payTypeStatus==='online'){
                    // 保存外部订单号
                    this.orderInfo.out_trade_no = res.data[0];
                    common.sessionJson('orderConfirm',this.orderInfo);
                    this.queryWxSign(res.data[0]);
                    return;
                }
                this.$router.push("/orderSuccess?orderid="+res.data.join(","));
            },res=>{
                this.$vux.toast.text(res.message);
            })
        },

        // 查询微信支付签名
        queryWxSign(outTradeNo){
            let _this = this;
            const opts = {
                url: api.wxPaySign,
                data: {
                    out_trade_no: outTradeNo,
                    amount: 0.01,
                },
                type: "get",
            }
            common.query(opts).then(res=>{

                WeixinJSBridge.invoke('getBrandWCPayRequest', {
                    "appId":"wx2421b1c4370ec43b",     //公众号ID，由商户传入
                    "timeStamp":"1395712654",         //时间戳，自1970年以来的秒数
                    "nonceStr":"e61463f8efa94090b1f366cccfbbb444", //随机串
                    "package":"prepay_id=u802345jgfjsdfgsdg888",
                    "signType":"MD5",         //微信签名方式：
                    "paySign":"70EA570631E4BB79628FBCA90534C63FF7FADD89", //微信签名
                    ...res.data
                },function(res){
                    if(res.err_msg == "get_brand_wcpay_request:ok" ){
                        // 使用以上方式判断前端返回,微信团队郑重提示：
                        //res.err_msg将在用户支付成功后返回ok，但并不保证它绝对可靠。
                        common.session('orderConfirm','');
                        _this.$router.push("/orderSuccess?orderid="+outTradeNo);
                    }
                    console.log(res);
                });

            },res=>{
                this.$vux.toast.text(res.message);
            })

        },

        // 选择支付类型
        selectPayType(typeObj){
            this.payType.map(val=>val.selected=false);
            typeObj.selected = true;
            this.payInfo = typeObj;
        },


    },
    mounted(){

        // pay 查询订单详情
        const order = common.sessionJson('orderConfirm') || {}
        const userInfo = common.storageJson('userInfo') || {};

        this.orderInfo = order

        this.payType = [
            //{label:'在线支付',icon:'icon_weixin',value: 2, selected:false, type: "online", show: userInfo.login_type==='wx' ? true : false},
            //{label:'付定金',icon:'icon_yfkj',value: 1,selected:false, type: "online", show: userInfo.login_type==='wx' ? true : false},
            {label:'货到付款',icon:'icon_hdfk',value: 0,selected:true, type: "offline", show: order.out_trade_no ? false : true}
        ]

        this.priceList = [
            order.storePrice && {label:'产品金额',value: order.storePrice},
            order.storeDeposit && {label:'押金',value: order.storeDeposit},
            order.storeShipping && {label:'运费',value: order.storeShipping},
            order.coupon && {label:'优惠卷',value: order.storeCoupon.coupon_value*-1},
        ]
    },
}



// WEBPACK FOOTER //
// ./src/views/member/orderPay.vue